<template>
  <router-view />
</template>

<script setup>
import { useQuasar } from 'quasar';
import { useAccountStore } from 'stores/account';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const $q = useQuasar();

$q.loading.hide();

const accountStore = useAccountStore();
locale.value = accountStore.account?.currentLanguage || 'de_DE';

$q.iconMapFn = (name) => {
  if (name.startsWith('fl:')) {
    return {
      cls: `fl-${name.slice(3)}`,
    };
  }
};
</script>
